import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { timeout, catchError, map, tap } from 'rxjs/operators';
import { MessageService } from '../services/message.service';
import { Observable, of } from 'rxjs';
import { GlobalVariables } from '../common/global-variables';

@Injectable({
  providedIn: 'root'
})
export class RssService {
  private rssUrl = 'https://www3.septa.org/api/rss/';
  private data: any = [];

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,  private messageService: MessageService) { }

    /** GET trains from api */
    get (): Observable<any[]> {

      this.data = this.http.jsonp<any[]>(this.rssUrl, 'callback')
      .pipe(
        timeout(GlobalVariables.timeout),
        map ((array: any) => array = this.transform(array)),
        tap (_ => this.log('fetched trains')),
        catchError (this.handleError<any[]>('get', []))
      );

      return this.data;
    }

    private transform(reponse: any): any{
      return reponse['channel']['item'];
    }

    private handleError<T> (operation = 'operation', result?: T) {
      return (error: any): Observable<T> => {

        // TODO: send the error to remote logging infrastructure
        console.error(error); // log to console instead

        // TODO: better job of transforming error for user consumption
        this.log('${operation} failed: ${error.message}');

        // Let the app keep running by returning an empty result.
        return of(result as T);
      };
    }

    /** Log a RouteService message with the MessageService */
    private log(message: string) {
      this.messageService.add(`RouteService: ${message}`);
    }
}
